import React from 'react';
import useReveal from '../hooks/useReveal';
import PageBanner from '../Components/PageBanner';
import ProjectSection from '../Components/ProjectSection';

const Projects = () => {
    useReveal();

    return (
        <div>
            <PageBanner
                title="Projects"
                text="facade, glazing, cladding and interior works across Delhi NCR."
                image="/projects/11/1.jpeg"
            />
            <ProjectSection />
        </div>
    );
};

export default Projects;
